import $ from 'jquery'
import ExcluConsultations from '@/views/parametres/assurances/liste-assures/assure-consultations'
import ExcluAnalyses from '@/views/parametres/assurances/liste-assures/assure-analyses'
import ExcluExamens from '@/views/parametres/assurances/liste-assures/assure-examens'
import ExcluMedicaments from '@/views/parametres/assurances/liste-assures/assure-medicaments'
import ExcluConsommables from '@/views/parametres/assurances/liste-assures/assure-consommables'
import ExcluActes from '@/views/parametres/assurances/liste-assures/assure-actes'
import ExcluAdmissions from '@/views/parametres/assurances/liste-assures/assure-admissions'
import ExcluChambres from '@/views/parametres/assurances/liste-assures/assure-chambres'
import ExcluObservations from '@/views/parametres/assurances/liste-assures/assure-observations'
import ExcluBilanSante from '@/views/parametres/assurances/liste-assures/assure-bilan-sante'
import ExcluChirurgie from '@/views/parametres/assurances/liste-assures/assure-chirurgie'

export default {
	name: 'assure-prestations',
	components: {
		ExcluConsultations, ExcluAnalyses, ExcluExamens, 
		ExcluMedicaments, ExcluConsommables, ExcluActes,
		ExcluAdmissions, ExcluChambres, ExcluObservations,
		ExcluBilanSante, ExcluChirurgie
	},
	props: [],
	data() {
		return {
			is_empty: false,
			param_med_empty: false,

			exclu_consult_is_loading: true,
			exclu_consult_is_empty: false,

			exclu_anly_is_loading: true,
			exclu_anly_is_empty: false,

			exclu_exm_is_loading: true,
			exclu_exm_is_empty: false,

			exclu_medoc_is_loading: true,
			exclu_medoc_is_empty: false,

			exclu_consommable_is_loading: true,
			exclu_consommable_is_empty: false,

			exclu_acte_is_loading: true,
			exclu_acte_is_empty: false,

			exclu_admission_is_loading: true,
			exclu_admission_is_empty: false,

			exclu_chambre_is_loading: true,
			exclu_chambre_is_empty: false,

			exclu_observation_is_loading: true,
			exclu_observation_is_empty: false,

			exclu_bilan_is_loading: true,
			exclu_bilan_is_empty: false,

			exclu_chirurgie_is_loading: true,
			exclu_chirurgie_is_empty: false,
			grouped_chirurgies: [],

			is_loading: true,
			loading: false,
			param_med_loading: true,

			checked_exclusions: [],

			cat_med_exclusions: [],

			u_loading: false,
			btn_disable: false,

			type_exclusion: 'consultation',
			assurance_id: 0,
			souscripteur_id: 0,

			type_prestations: [
                {
					type: 'consultation',
                    libelle: 'Consultations',
                    id: '1',
                },
                {
					type: 'analyse',
                    libelle: 'Analyses',
                    id: '2',
                },
				{
					type: 'examen',
                    libelle: 'Examens',
                    id: '3',
                },
				{
					type: 'medicament',
                    libelle: 'Médicaments',
                    id: '4',
                },
				{
					type: 'consommable',
                    libelle: 'Consommables',
                    id: '5',
                },
				{
					type: 'chirurgie',
                    libelle: 'Chirurgies',
                    id: '6',
                },
				{
					type: 'bilan_sante',
                    libelle: 'Bilan de santé',
                    id: '7',
                },
				{
					type: 'acte',
					libelle: 'Actes',
                    id: '8',
				},
				{
					type: 'chambre',
					libelle: 'Chambres',
                    id: '9',
				},
				{
					type: 'observation',
					libelle: 'Observations',
                    id: '10',
				},
				{
					type: 'admission',
					libelle: 'Admissions',
                    id: '11',
				}
            ],
			selected_type_prestation: {
				type: 'consultation',
				libelle: 'Consultations',
				id: '1',
			},
		}
	},

	computed: {
		/**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

		// Consultations
		list_consultations() {
            return this.$store.getters["list_consultations"];
        },

		params_prestation_all() {
            return this.$store.getters["params_prestation_all"];
        },

		params_prestations() {
            return this.$store.getters["params_prestations"];
        },

		params_prestation_non_exclus() {
            return this.$store.getters["params_prestation_non_exclus"];
        },

		// ---------	MEDICAMENTS 	----------
		params_cat_medicament_exclus() {
            return this.$store.getters["params_cat_medicament_exclus"];
        },

		params_cat_medicaments_all() {
            return this.$store.getters["params_cat_medicaments_all"];
        },

		/**
		 * ================================================
		 * 		LISTE DES EXCLUSION PAR PRESATATION
		 */
		list_exclu_consultations() {
            return this.$store.getters["list_exclu_consultations"];
        },

		list_exclu_analyses() {
            return this.$store.getters["list_exclu_analyses"];
        },

		list_exclu_examens() {
            return this.$store.getters["list_exclu_examens"];
        },

		list_exclu_medicaments() {
            return this.$store.getters["list_exclu_medicaments"];
        },

		list_exclu_consommables() {
            return this.$store.getters["list_exclu_consommables"];
        },

		list_exclu_actes() {
            return this.$store.getters["list_exclu_actes"];
        },

		list_exclu_admissions() {
            return this.$store.getters["list_exclu_admissions"];
        },

		list_exclu_chambres() {
            return this.$store.getters["list_exclu_chambres"];
        },

		list_exclu_observations() {
            return this.$store.getters["list_exclu_observations"];
        },

		list_exclu_bilan_santes() {
            return this.$store.getters["list_exclu_bilan_santes"];
        },

		list_exclu_chirurgies() {
            return this.$store.getters["list_exclu_chirurgies"];
        },
	},

	mounted() {
		this.user_id = this.userCredentials.id
		this.assurance_id = this.$route.params.id
		this.souscripteur_id = this.$route.params.assure_id

		/**
		 * Liste des prestations exclus
		 */
		this.$store.dispatch("listePrestationSouscripteur", { 
			assurance_id: this.$route.params.id, souscripteur_id: this.$route.params.assure_id, est_exclu: 1 
		} ).then(() => {
			// this.checked_exclusions = (this.params_prestations)
			if(this.params_prestations.length > 0) {
				this.is_empty = false
			} else {
				this.is_empty = true
			}
			this.is_loading = false
		});

		/**
		 * Liste de toutes les prestations ( exclus et non exclus )
		 */
		this.$store.dispatch("listeAllPrestationSouscripteur", { 
			assurance_id: this.$route.params.id, souscripteur_id: this.$route.params.assure_id
		} ).then(() => {
			this.checked_exclusions = (this.params_prestation_all)
		});

		// ===============		LISTE DES EXCLUSIONS PAR PRESTATION 		==================
		this.refreshConsultationExclu()

		this.refreshAnalyseExclu()

		this.refreshExamenExclu()
		
		this.refreshMedicamentExclu()

		this.refreshConsommableExclu()

		this.refreshActeExclu()

		this.refreshAdmissionExclu()

		this.refreshChambreExclu()

		this.refreshObservationExclu()

		this.refreshBilanSanteExclu()

		this.refreshChirurgieExclu()
	},
	
	methods: {
		handleChangeTypePrestation() {
			this.type_exclusion = this.selected_type_prestation.type
			let id_selected = this.selected_type_prestation.id

			if (id_selected > 0) {
				for(let i = 1; i <= this.type_prestations.length; i++) {
					if (i != id_selected ) {
						$('.exclu-'+i).fadeOut(500)
					}
				}
				setTimeout(() => {
					$('.exclu-'+id_selected ).fadeIn(500)
				}, 500);
			} 
		},

		refreshConsultationExclu() {
			this.exclu_consult_is_loading = true
			let data = {
				type_prestation: 'consultation',
				assurance_id: this.$route.params.id,
				souscripteur_id: this.$route.params.assure_id
			}
			this.$store.dispatch("getListExclusByPrestation", data).then(() => {
				if(this.list_exclu_consultations.length > 0) {
					this.exclu_consult_is_empty = false
				} else {
					this.exclu_consult_is_empty = true
				}
				this.exclu_consult_is_loading = false
			})
		},

		refreshAnalyseExclu() {
			this.exclu_anly_is_loading = true
			let data_anly = {
				type_prestation: 'analyse',
				assurance_id: this.$route.params.id,
				souscripteur_id: this.$route.params.assure_id
			}
			this.$store.dispatch("getListExclusByPrestation", data_anly).then(() => {
				if(this.list_exclu_analyses.length > 0) {
					this.exclu_anly_is_empty = false
				} else {
					this.exclu_anly_is_empty = true
				}
				this.exclu_anly_is_loading = false
			})
		},

		refreshExamenExclu() {
			this.exclu_exm_is_loading = true
			let data_examen = {
				type_prestation: 'examen',
				assurance_id: this.$route.params.id,
				souscripteur_id: this.$route.params.assure_id
			}
			this.$store.dispatch("getListExclusByPrestation", data_examen).then(() => {
				if(this.list_exclu_examens.length > 0) {
					this.exclu_exm_is_empty = false
				} else {
					this.exclu_exm_is_empty = true
				}
				this.exclu_exm_is_loading = false
			})
		},

		refreshMedicamentExclu() {
			this.exclu_medoc_is_loading = true
			let data_medicament = {
				type_prestation: 'medicament',
				assurance_id: this.$route.params.id,
				souscripteur_id: this.$route.params.assure_id
			}
			this.$store.dispatch("getListExclusByPrestation", data_medicament).then(() => {
				if(this.list_exclu_medicaments.length > 0) {
					this.exclu_medoc_is_empty = false
				} else {
					this.exclu_medoc_is_empty = true
				}
				this.exclu_medoc_is_loading = false
			})
		},

		refreshConsommableExclu() {
			this.exclu_consommable_is_loading = true
			let data = {
				type_prestation: 'consommable',
				assurance_id: this.$route.params.id,
				souscripteur_id: this.$route.params.assure_id
			}

			this.$store.dispatch("getListExclusByPrestation", data).then(() => {
				if(this.list_exclu_consommables.length > 0) {
					this.exclu_consommable_is_empty = false
				} else {
					this.exclu_consommable_is_empty = true
				}
				this.exclu_consommable_is_loading = false
			})
		},

		refreshActeExclu() {
			this.exclu_acte_is_loading = true
			let data = {
				type_prestation: 'acte',
				assurance_id: this.$route.params.id,
				souscripteur_id: this.$route.params.assure_id
			}

			this.$store.dispatch("getListExclusByPrestation", data).then(() => {
				if(this.list_exclu_actes.length > 0) {
					this.exclu_acte_is_empty = false
				} else {
					this.exclu_acte_is_empty = true
				}
				this.exclu_acte_is_loading = false
			})
		},

		refreshAdmissionExclu() {
			this.exclu_admission_is_loading = true
			let data = {
				type_prestation: 'admission',
				assurance_id: this.$route.params.id,
				souscripteur_id: this.$route.params.assure_id
			}

			this.$store.dispatch("getListExclusByPrestation", data).then(() => {
				if(this.list_exclu_admissions.length > 0) {
					this.exclu_admission_is_empty = false
				} else {
					this.exclu_admission_is_empty = true
				}
				this.exclu_admission_is_loading = false
			})
		},

		refreshChambreExclu() {
			this.exclu_chambre_is_loading = true
			let data = {
				type_prestation: 'chambre',
				assurance_id: this.$route.params.id,
				souscripteur_id: this.$route.params.assure_id
			}

			this.$store.dispatch("getListExclusByPrestation", data).then(() => {
				if(this.list_exclu_chambres.length > 0) {
					this.exclu_chambre_is_empty = false
				} else {
					this.exclu_chambre_is_empty = true
				}
				this.exclu_chambre_is_loading = false
			})
		},

		refreshObservationExclu() {
			this.exclu_observation_is_loading = true
			let data = {
				type_prestation: 'observation',
				assurance_id: this.$route.params.id,
				souscripteur_id: this.$route.params.assure_id
			}

			this.$store.dispatch("getListExclusByPrestation", data).then(() => {
				if(this.list_exclu_observations.length > 0) {
					this.exclu_observation_is_empty = false
				} else {
					this.exclu_observation_is_empty = true
				}
				this.exclu_observation_is_loading = false
			})
		},

		refreshBilanSanteExclu() {
			this.exclu_bilan_is_loading = true
			let data = {
				type_prestation: 'bilan_sante',
				assurance_id: this.$route.params.id,
				souscripteur_id: this.$route.params.assure_id
			}

			this.$store.dispatch("getListExclusByPrestation", data).then(() => {
				if(this.list_exclu_bilan_santes.length > 0) {
					this.exclu_bilan_is_empty = false
				} else {
					this.exclu_bilan_is_empty = true
				}
				this.exclu_bilan_is_loading = false
			})
		},

		refreshChirurgieExclu() {
			this.exclu_chirurgie_is_loading = true
			let data = {
				type_prestation: 'chirurgie',
				assurance_id: this.$route.params.id,
				souscripteur_id: this.$route.params.assure_id
			}

			this.$store.dispatch("getListExclusByPrestation", data).then(() => {
				if(this.list_exclu_chirurgies.length > 0) {
					this.exclu_chirurgie_is_empty = false

					this.groupChirurgieExclu()
				} else {
					this.exclu_chirurgie_is_empty = true
				}
				this.exclu_chirurgie_is_loading = false
			})
		},

		groupChirurgieExclu() {
			this.grouped_chirurgies = []
			Array.prototype.groupBy = function (key) {
				return this
					.reduce((hash, obj) => {
						if (obj[key] === undefined) return hash;
						return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
					}, {})
			};

			const tmp_grouped_chirurgie = this.list_exclu_chirurgies.groupBy('chirurgie')

			for (const key in tmp_grouped_chirurgie) {
                const tmp_group = {
                    chirurgie: key,
                    kchirurgies: tmp_grouped_chirurgie[key],
                }
                this.grouped_chirurgies.push(tmp_group)
            }
		},

		refreshPrestationExclu() {
			this.is_loading = true
			this.param_med_loading = true
			this.$store.dispatch("listePrestationSouscripteur", { 
				assurance_id: this.$route.params.id, souscripteur_id: this.$route.params.assure_id, est_exclu: 1 
			} ).then(() => {
				if(this.params_prestations.length > 0) {
					this.is_empty = false
				} else {
					this.is_empty = true
				}
				this.is_loading = false
			});

			// >>>>>>> Liste des medicaments exclus
			this.$store.dispatch("listeMedCategorieSouscripteur", { 
				assurance_id: this.$route.params.id, souscripteur_id: this.$route.params.assure_id, est_exclu: 1 
			} ).then(() => {
				if(this.params_cat_medicament_exclus.length > 0) {
					this.param_med_empty = false
				} else {
					this.param_med_empty = true
				}
				this.param_med_loading = false
			});
		},

		onExclusion(index) {
			let j_deactivate = document.getElementById('prest'+index);

			if (j_deactivate.checked) {
				this.checked_exclusions[index].est_exclusion = 1
			} else {
				this.checked_exclusions[index].est_exclusion = 0
			}
		},

		onCatMedExclusion(index) {
			let j_deactivate = document.getElementById('med'+index);

			if (j_deactivate.checked) {
				this.cat_med_exclusions[index].est_exclusion = 1
			} else {
				this.cat_med_exclusions[index].est_exclusion = 0
			}
		},

		update() {
			this.loading = true
            this.btn_disable = true
			
			let data = {
				checked_exclusions: this.checked_exclusions,
				cat_med_exclusions: this.cat_med_exclusions
			}

			this.$store.dispatch("updatePrestation", { 
				assurance_id: this.$route.params.id, souscripteur_id: this.$route.params.assure_id, 
				checked_exclusions: data
			}).then((response) => {
				if (response > 0) {
					this.refreshPrestationExclu()
					$('.modal').modal('hide')	

					this.successMsg("Mise à jour des exclusions effectuée avec succès")
				}
				

				this.loading = false;
                this.btn_disable = false
			})
		},

		successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        }, 

		// param_exclu_consultation() {
		// 	return this.$store.getters["params_cat_medicaments_all"];
		// },

		updateExclusion(type_exclusion) {
			let list_exclusions = []
			if (type_exclusion == 'consultation') {
				// >>> EXCLUSION CONSULTATION
				list_exclusions = this.$store.getters["param_exclu_consultation"]
			} else if (type_exclusion == 'analyse') {
				// >>> EXCLUSION ANALYSE
				list_exclusions = this.$store.getters["param_exclu_analyse"]
			} else if (type_exclusion == 'examen') {
				// >>> EXCLUSION EXAMEN
				list_exclusions = this.$store.getters["param_exclu_examen"]
			} else if (type_exclusion == 'medicament') {
				// >>> EXCLUSION MEDICAMENT
				list_exclusions = this.$store.getters["param_exclu_medicament"]
			} else if (type_exclusion == 'consommable') {
				// >>> EXCLUSION CONSOMMABLE
				list_exclusions = this.$store.getters["param_exclu_consommable"]
			} else if (type_exclusion == 'acte') {
				// >>> EXCLUSION ACTE
				list_exclusions = this.$store.getters["param_exclu_acte"]
			} else if (type_exclusion == 'admission') {
				// >>> EXCLUSION ACTE
				list_exclusions = this.$store.getters["param_exclu_admission"]
			} else if (type_exclusion == 'chambre') {
				// >>> EXCLUSION ACTE
				list_exclusions = this.$store.getters["param_exclu_chambre"]
			} else if (type_exclusion == 'observation') {
				// >>> EXCLUSION ACTE
				list_exclusions = this.$store.getters["param_exclu_observation"]
			} else if (type_exclusion == 'bilan_sante') {
				// >>> EXCLUSION ACTE
				list_exclusions = this.$store.getters["param_exclu_bilan_sante"]
			} else if (type_exclusion == 'chirurgie') {
				// >>> EXCLUSION ACTE
				list_exclusions = this.$store.getters["param_exclu_chirurgie"]
			}


			this.loading = true
			this.btn_disable = true

			let data = {
				type_prestation: type_exclusion,
				list_exclu: list_exclusions,
				assurance_id: this.$route.params.id,
				souscripteur_id: this.$route.params.assure_id
			}

			this.$store.dispatch('setExclusion', data).then((response) => {
				if (response.success) {
					this.successMsg("Exclusion ajoutée avec succès.")

					$('.modal').modal('hide')

					if (type_exclusion == 'consultation') {
						this.refreshConsultationExclu()
					} else if (type_exclusion == 'analyse') {
						this.refreshAnalyseExclu()
					} else if (type_exclusion == 'examen') {
						this.refreshExamenExclu()
					} else if (type_exclusion == 'medicament') {
						this.refreshMedicamentExclu()
					} else if (type_exclusion == 'consommable') {
						this.refreshConsommableExclu()
					} else if (type_exclusion == 'acte') {
						this.refreshActeExclu()
					} else if (type_exclusion == 'admission') {
						this.refreshAdmissionExclu()
					} else if (type_exclusion == 'chambre') {
						this.refreshChambreExclu()
					} else if (type_exclusion == 'observation') {
						this.refreshObservationExclu()
					} else if (type_exclusion == 'bilan_sante') {
						this.refreshBilanSanteExclu()
					} else if (type_exclusion == 'chirurgie') {
						this.refreshChirurgieExclu()
					}
				} else {
					if (response.code == 500) {
						this.errorToast("Une erreur s'est produite lors de l'enregistrement !")
					}
				}
				this.loading = false
				this.btn_disable = false
			})	
		}
	}
}